import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core'
import { CoreService } from '../../../services'

@Component({
  selector: 'form-row-password',
  templateUrl: 'form-row-password.component.html',
  styles: [
    `
      .form-group .input-group .input-group-text {
        padding-top: 10px;
      }
    `,
  ],
  styleUrls: ['./form-row-password.component.scss'],
})
export class FormRowPasswordComponent implements OnInit, OnChanges {
  passwordA: string
  passwordB: string
  @Input() label: string = 'password.new'
  @Input() isSingleInput: boolean = false
  @Input() isPlaintextInput: boolean = false
  @Input() model: string
  @Output() modelChange: EventEmitter<any> = new EventEmitter()
  @Output() validityChange: EventEmitter<any> = new EventEmitter()
  @Output() valueChangeNative: EventEmitter<any> = new EventEmitter()
  @Output() onKeyPress: EventEmitter<KeyboardEvent> = new EventEmitter()
  @Output() onBlur: EventEmitter<any> = new EventEmitter()
  @Output() onFocused: EventEmitter<any> = new EventEmitter()
  @Input() inputDisabled = false
  @Input() inputRequired = false
  @Input() inputReadonly = false
  @Input() maxlength = 255
  @Input() showErrorBorder: boolean
  @Input() maxWidthPx: string | number = 'none'
  @Input() disallowTabNavToBtn: boolean
  isFocused: boolean
  isErrorShown: boolean
  passwordStrength: number = 0
  passwordStrengthStrings: string[] = [
    'passwordStrength.0',
    'passwordStrength.1',
    'passwordStrength.2',
    'passwordStrength.3',
    'passwordStrength.4',
  ]
  passwordStrengthString: string = this.passwordStrengthStrings[0]
  hasPasswordLowerCaseChar: boolean = false
  hasPasswordUpperCaseChar: boolean = false
  hasPasswordNumericChar: boolean = false
  hasPasswordSymbolChar: boolean = false
  doesAAndBMatch: boolean = true
  isPasswordValid: boolean = false
  constructor(private core: CoreService) {}

  ngOnInit() {
    this.passwordA = this.model || ''
  }

  ngOnChanges() {
    this.checkPassStr()
  }

  onInputValueChange(event: any): void {
    this.valueChangeNative.emit(event)
  }

  onInputKeyPress(event: KeyboardEvent): void {
    this.onKeyPress.emit(event)
  }

  onFocus(isFocused: boolean) {
    this.isFocused = isFocused
    if (!isFocused) {
      this.onBlur.emit()
    } else {
      this.onFocused.emit()
    }
  }

  passAModelChange(event: string) {
    this.passwordA = event
    this.checkPassStr()
  }

  passBModelChange(event: string) {
    this.passwordB = event
    this.checkPassStr()
  }

  checkPassStr() {
    if (!this.passwordA) {
      this.hasPasswordLowerCaseChar = false
      this.hasPasswordUpperCaseChar = false
      this.hasPasswordNumericChar = false
      this.hasPasswordSymbolChar = false
      this.passwordStrength = 0
      this.passwordStrengthString = this.passwordStrengthStrings[this.passwordStrength]
      return
    }
    this.hasPasswordLowerCaseChar = !!this.passwordA.match(/[a-z]/)
    this.hasPasswordUpperCaseChar = !!this.passwordA.match(/[A-Z]/)
    this.hasPasswordNumericChar = !!this.passwordA.match(/[0-9]/)
    this.hasPasswordSymbolChar = !!this.passwordA.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) // eslint-disable-line no-useless-escape
    if (this.passwordA.length < 8) {
      this.passwordStrength = 0
    }
    if (this.passwordA.length >= 8 && this.passwordA.length <= 9) {
      this.passwordStrength = 1
    }
    if (this.passwordA.length >= 10 && this.passwordA.length <= 11) {
      this.passwordStrength = 2
    }
    if (this.passwordA.length >= 12) {
      this.passwordStrength = 3
    }
    if (this.passwordA.length >= 12 && this.hasPasswordSymbolChar) {
      this.passwordStrength = 4
    }
    this.passwordStrengthString = this.passwordStrengthStrings[this.passwordStrength]
    if (this.passwordB?.length && this.passwordA !== this.passwordB) {
      this.passwordStrengthString = 'passwordStrength.doesntMatch'
      this.doesAAndBMatch = false
    } else {
      this.doesAAndBMatch = true
    }
    this.modelChange.emit(this.passwordA)
    this.isPasswordValid =
      this.passwordA.length >= 8 &&
      this.hasPasswordLowerCaseChar &&
      this.hasPasswordUpperCaseChar &&
      this.hasPasswordNumericChar &&
      this.doesAAndBMatch
    this.validityChange.emit(this.isPasswordValid)
  }
}
